import React, { useState } from "react";
import Timer from "./Timer";

export default function BaseView() {
  const [showInvitation, setShowInvitation] = useState(false);
  const weddingDate = new Date(2026, 5, 21, 18, 0);
  return (
    <div className="flex min-h-screen w-full items-center justify-center overflow-auto bg-gradient-to-r from-[rgb(193,181,215)] to-[rgb(149,125,197)]   ">
      <div className="flex-col justify-center font-wedding text-2xl text-white md:text-3xl">
        <div className="m-5 flex justify-center p-4">
          {weddingDate.getTime() >= Date.now().valueOf() ? (
            <span>Остават още</span>
          ) : (
            <span>Вече измиаха</span>
          )}
        </div>
        <div className="m-5 p-4">
          <Timer weddingDate={weddingDate} />
        </div>
        <div className="m-5 flex justify-center p-4 font-wedding">
          {weddingDate.getTime() >= Date.now().valueOf() ? (
            <span>до нашата сватба!</span>
          ) : (
            <span>от нашата сватба!</span>
          )}
        </div>
      </div>
    </div>
  );
}
